import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsHiddenLeversRTQ } from '../CommonSelectors/CommonAreaSelector';
import { HiddenLeversRTQ } from '../Profile/Components/workflows/HiddenLeversRTQ/HiddenLeversRTQ';
import { OrionRiskToleranceWorkflow } from './components/OrionRiskToleranceWorkflow/OrionRiskToleranceWorkflow';
import { OrionRiskIntelligenceQuestionnaire } from '../Profile/Components/workflows/OrionRiskIntelligenceQuestionnaire/OrionRiskIntelligenceQuestionnaire';
import { useFeatureFlag } from '../_hooks/useFeatureFlag';
import { Feature } from '../CommonSelectors/CommonArea.types';
import { useOrionRiskIntelligenceWorkflowQuery } from '../Profile/Components/workflows/OrionRiskIntelligenceQuestionnaire/api/useOrionRiskIntelligenceWorkflowQuery';
import { FullPageLoading } from '../CommonComponents/OPL/FullpageLoading/FullPageLoading';

interface Props {
  isAutoAccountsWorkflow?: boolean;
  onFinish?(): void;
}

export const RiskToleranceWorkflow = ({ isAutoAccountsWorkflow, onFinish }: Props) => {
  const isHiddenLeversRTQ = useSelector(selectIsHiddenLeversRTQ);
  const isORIComponent = useFeatureFlag(Feature.UseOriRtqWebComponent);

  const { isLoading, error } = useOrionRiskIntelligenceWorkflowQuery(isORIComponent);

  if (isLoading) {
    return <FullPageLoading text="Loading" />;
  }

  if (isORIComponent && !error) {
    return <OrionRiskIntelligenceQuestionnaire onFinish={onFinish} />;
  }

  if (isHiddenLeversRTQ) {
    return <HiddenLeversRTQ onFinish={onFinish} />;
  }

  return (
    <OrionRiskToleranceWorkflow
      isAutoAccountsWorkflow={isAutoAccountsWorkflow}
      onFinish={onFinish}
    />
  );
};
